// opervex-frontend/src/Opervex/Accounting/CostCenters.js

class CostCenters {
  #_api;
  constructor(api) {
    this.#_api = api;
  }
  async findAll() {
    return this.#_api.get("/Accounting/CostCenters");
  }
  async findId(id) {
    return this.#_api.get(`/Accounting/CostCenters/${id}`);
  }
  async create(data) {
    return this.#_api.post("/Accounting/CostCenters", data);
  }
  async update(id, data) {
    return this.#_api.put(`/Accounting/CostCenters/${id}`, data);
  }
  async schema() {
    return [
      { key: "id", label: "Código", type: "string", visible: true },
      { key: "description", label: "Descrição", type: "string", visible: true },
      { key: "disabled", label: "Inativo", type: "boolean", visible: true },
    ];
  }
}
export default CostCenters;
